import gql from "graphql-tag";

export default gql`
mutation SetFilter(
    $visible: Boolean
    $customer: SelectItem
    $transporter: selectItem!
    $departure: [SelectItem]
    $destination: [SelectItem]
    $employer: [SelectItem]
    $pax: [PaxGlobalFilter]
    $cgo: [CgoGlobalFilter]
){
    setGlobalFilter(
        visible: $visible
        customer: $customer
        transporter: $transporter
        departure: $departure
        destination: $destination
        employer: $employer
        pax: $pax
        cgo: $cgo
    ) @client {
        visible
        customer
        transporter
        departure {
            key
            label
        }
        destination {
            key
            label
        }
        employer {
            key
            label
        }
        pax {
            lastName
            firstName
        }
        cgo {
            name
        }
    }
}
`